import * as React from "react";

const VerifyIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="196" height="162" {...props}>
    <path
      fill="#3F3D56"
      d="M26.332 55.864a10.2 10.2 0 0 1-2.538-.329l-.164-.045-.151-.076c-5.481-2.748-10.105-6.377-13.743-10.788a40.8 40.8 0 0 1-6.94-12.322A47.4 47.4 0 0 1 .116 15.598l.004-.275c0-2.763 1.534-5.188 3.908-6.177C5.843 8.39 22.339 1.614 23.53 1.124 25.775 0 28.17.938 28.553 1.103c.86.351 16.108 6.588 19.404 8.157 3.396 1.617 4.302 4.523 4.302 5.984 0 6.618-1.146 12.802-3.407 18.382a42.6 42.6 0 0 1-7.649 12.327c-6.244 7.027-12.49 9.518-12.55 9.54a6.8 6.8 0 0 1-2.32.37m-1.469-3.639c.542.122 1.789.304 2.601.007 1.032-.376 6.26-3.087 11.145-8.584 6.75-7.596 10.174-17.144 10.18-28.38-.013-.227-.175-1.85-2.325-2.874-3.231-1.539-19.08-8.02-19.24-8.085l-.044-.019c-.333-.14-1.39-.432-2.118-.05l-.146.068c-.177.072-17.687 7.264-19.554 8.042-1.307.544-1.772 1.893-1.772 2.973q0 .12-.005.342c-.15 7.688 1.63 26.606 21.278 36.56"
    />
    <path
      fill="#6C63FF"
      d="M24.256 2.702S6.587 9.96 4.694 10.748s-2.84 2.682-2.84 4.575-1.42 26.596 22.402 38.54c0 0 2.162.598 3.803 0 1.64-.598 22.464-10.695 22.464-38.619 0 0 0-2.84-3.312-4.417C43.898 9.249 27.88 2.702 27.88 2.702s-1.967-.867-3.624 0"
    />
    <path 
    fill="rgba(0, 0, 0, 1)"
    opacity= "0.1"
    d="M26.15 8.382v38.713S8.323 38.514 8.48 15.955z" />

    <path
      fill="#fff"
      d="m26.382 36.206-5.679-7.302 3.303-2.569 2.689 3.458 9.083-9.59 3.038 2.879z"
    />
    <path fill="#FFB6B6" d="M141.76 155.944h-4.21l-2.002-16.239h6.213z"></path>
    <path
      fill="#2F2E41"
      d="M142.834 154.569h-8.29a5.284 5.284 0 0 0-5.284 5.283v.172h13.574z"
    ></path>
    <path
      fill="#FFB6B6"
      d="m192.084 150.326-3.666 2.07-9.727-13.156 5.41-3.054z"
    ></path>
    <path
      fill="#2F2E41"
      d="m192.343 148.601-7.22 4.075a5.284 5.284 0 0 0-2.003 7.198l.085.15 11.82-6.674zM165.178 82.918l.325 1.624s.975.974.487 1.462c-.487.487-.324 2.761-.324 2.761.272 4.147 5.69 27.448 6.66 31.999 0 0 7.471 4.873 13.319 14.456 5.847 9.583 6.009 12.02 6.009 12.02l-6.496 2.762-16.242-19.654s-4.548-2.762-6.172-5.198c-1.625-2.436-11.697-27.614-11.697-27.614l-5.687 26.314s.325 9.584-1.137 15.756a66 66 0 0 0-1.624 11.858l-7.634-.812s.487-23.066 1.3-25.502c0 0-3.412-28.101 3.41-39.309l5.499-14.658 5.384-2.072z"
    ></path>
    <path
      fill="#3F3D56"
      d="m150.144 40.557 5.981-1.581 8.367-.421 4.797 2.904-4.198 42.086s-22.649-1.195-22.663-8.109l2.122-6.143z"
    ></path>
    <path
      fill="#FFB6B6"
      d="M170.015 87.559a3.22 3.22 0 0 1 .927-4.85L170.1 75.4l4.318-1.595 1.043 10.34a3.237 3.237 0 0 1-5.446 3.414"
    ></path>
    <path
      fill="#3F3D56"
      d="m166.637 45.602 2.548-3.562s1.744-.387 3.804 2.017 3.262 32.449 3.262 32.449l-7.554 1.717-4.464-21.29z"
    ></path>
    <path
      fill="#fff"
      d="m123.949 78.184.562 26.693 17.28 9.132 31.47-5.62.773-27.746-19.95-7.025z"
    ></path>
    <path
      fill="#CACACA"
      d="m141.746 114.298-17.508-9.253-.57-27.097 30.443-4.613.065.023 20.14 7.091-.785 28.173zm-16.963-9.589 17.053 9.012 31.156-5.564.76-27.32-19.694-6.936-29.828 4.52z"
    ></path>
    <path
      fill="#CACACA"
      d="m141.406 85.422-.068-.027-17.491-6.955.204-.512 17.423 6.927 32.522-4.486.076.547z"
    ></path>
    <path
      fill="#CACACA"
      d="m141.164 85.142.552-.007.351 28.87-.552.008zM139.196 84.04l-6.305-2.556 30.353-4.837 6.305 2.556zM123.84 86.434l.219-.506 7.313 3.148-.219.507z"
    ></path>
    <path
      fill="#6C63FF"
      d="m127.152 95.54.218-.506 7.313 3.148-.219.507z"
    ></path>
    <path
      fill="#fff"
      d="m27.804 115.27.562 26.692 17.28 9.132 31.47-5.62.773-27.746-19.95-7.025z"
    ></path>
    <path
      fill="#CACACA"
      d="m45.601 151.383-17.508-9.253-.57-27.097 30.443-4.613.065.023 20.14 7.091-.785 28.173zm-16.963-9.589 17.053 9.012 31.155-5.564.761-27.32-19.695-6.936-29.827 4.52z"
    ></path>
    <path
      fill="#CACACA"
      d="m45.26 122.506-.067-.027-17.491-6.954.204-.513 17.423 6.927 32.522-4.485.076.546z"
    ></path>
    <path
      fill="#CACACA"
      d="m45.019 122.226.552-.006.351 28.87-.552.007zM41.523 120.496l-4.778-1.928 30.353-4.836 4.777 1.928zM27.695 123.52l.218-.508 7.313 3.149-.219.507z"
    ></path>
    <path
      fill="#6C63FF"
      d="m31.006 132.625.218-.507 7.313 3.149-.218.507zM57.825 118.928l.652 30.987 20.06 10.6 36.531-6.523.897-32.21-23.158-8.154z"
    ></path>
    <path
      fill="#3F3D56"
      d="m78.484 160.851-20.323-10.74-.663-31.457 35.34-5.354.075.026 23.379 8.232-.91 32.704zm-19.69-11.13 19.795 10.46 36.166-6.458.883-31.715-22.862-8.05-34.625 5.246z"
    ></path>
    <path
      fill="#3F3D56"
      d="m78.09 127.33-.08-.03-20.304-8.074.237-.595 20.226 8.042 37.752-5.207.088.634z"
    ></path>
    <path
      fill="#3F3D56"
      d="m77.809 127.006.64-.008.408 33.515-.64.007zM74.075 125.012l-5.871-2.252 35.235-5.615 5.87 2.252zM57.698 128.506l.253-.588 8.49 3.654-.254.589z"
    ></path>
    <path fill="#fff" d="m61.542 139.077.253-.588 8.49 3.654-.254.589z"></path>
    <path
      fill="#FFB6B6"
      d="M133.747 82.598a3.22 3.22 0 0 0 1.261-4.773l3.922-6.225-3.201-3.306-5.416 8.869a3.237 3.237 0 0 0 3.434 5.435"
    ></path>
    <path
      fill="#3F3D56"
      d="m152.793 43.504-2.81-1.851s-2.169.486-4.475 4.922-11.606 24.267-11.606 24.267l3.823 3.88 10.198-15.558z"
    ></path>
    <path
      fill="#FFAFAF"
      d="m163.054 36.036 2.265 3.916-8.56 3.548.105-6.278z"
    ></path>
    <path
      fill="#FFAFAF"
      d="M164.492 32.388q0 .162-.01.324-.009.162-.027.324-.019.161-.047.322-.027.16-.064.32-.037.158-.083.316-.046.157-.1.313-.056.155-.12.308-.063.152-.136.302-.072.15-.153.297-.08.147-.17.29-.089.143-.186.282-.097.14-.202.274-.105.135-.218.265t-.233.256-.247.246-.26.235-.274.224-.286.212q-.146.102-.298.2-.152.096-.31.186-.157.09-.319.174t-.329.16-.337.145-.346.132-.353.117-.359.101-.364.087-.369.07q-.185.033-.372.056-.187.024-.376.04-.188.016-.377.024t-.378.008-.378-.008q-.188-.008-.377-.024-.188-.016-.375-.04-.187-.023-.372-.055-.186-.032-.37-.071-.183-.04-.363-.087-.181-.047-.36-.101-.177-.055-.352-.117t-.346-.132-.337-.146-.33-.16-.319-.173q-.157-.09-.309-.187t-.298-.2-.286-.211-.274-.224-.26-.235-.248-.246-.232-.256-.218-.265-.202-.274-.187-.282-.17-.29q-.08-.147-.153-.297-.072-.15-.136-.302-.063-.153-.118-.308-.055-.156-.101-.313-.046-.158-.083-.317t-.065-.32q-.027-.16-.046-.321-.018-.162-.028-.324-.009-.162-.009-.324 0-.163.01-.325.009-.162.027-.323.019-.162.046-.322.028-.16.065-.32.037-.159.083-.316.046-.158.1-.313.056-.155.12-.308.063-.153.135-.303t.154-.297.17-.29.186-.282.202-.274.218-.265.232-.256.247-.245.261-.235.274-.224.286-.212.298-.2.31-.186q.156-.09.319-.174.162-.083.329-.16.166-.076.337-.146t.346-.131q.175-.062.353-.117t.359-.102q.18-.047.364-.086.183-.04.369-.071.185-.032.372-.056t.375-.04q.189-.016.377-.024.19-.008.378-.008.19 0 .378.008.19.008.377.024.189.016.376.04t.372.056q.185.031.369.07.183.04.364.087t.36.102.352.117.346.131.337.146q.167.077.33.16.161.083.319.174.157.09.309.186.152.097.298.2t.286.212.274.224.26.235.247.245.233.256.218.265.202.274.186.283.17.29q.081.146.153.296.073.15.137.303.063.153.118.308t.1.313q.047.157.084.316.037.16.064.32t.047.322q.018.161.027.323t.01.325"
    ></path>
    <path
      fill="#2F2E41"
      d="m164.71 35.714-1.423.875s-.42-3.816-.998-3.985-1.358.71-1.358.71l-.57 1.433-1.883-.674s-2.182-1.008-2.952-1.234c-.771-.226-.654-2.143-.654-2.143s-9.255 1.087-7.865-3.491c0 0 .48-3.369 1.504-2.7 1.025.67 1.039-.988 1.039-.988l2.321-.428s3.187-3.683 9.472-.55 3.368 13.175 3.368 13.175"
    ></path>
    <path
      fill="#6C63FF"
      d="m158.958 27.595-8.474-4.825s-10.946-2.893-6.823 2.639l3.488.611s9.484 1.898 11.809 1.575"
    ></path>
    <path
      fill="#6C63FF"
      d="m156.408 26.502 8.848 5.726s5.172-7.915-2.927-11.839-13.232 2.222-13.232 2.222l2.136 1.962z"
    ></path>
  </svg>
);

export default VerifyIconSVG;
